import React from "react";
import styled from "styled-components";
import JsonDiffReact from "jsondiffpatch-for-react";
import NoFooterModal from "../../Common/NoFooterModal";

const ChangeLogsDiffModal = (props) => {
  const { handleModalClose, modalState, old_value, updated_value, Source } =
    props;

  return (
    <div className="change-logs-diff-modal" id="jsondiffModal">
      <NoFooterModal
        handleClose={handleModalClose}
        heading={Source + " Change Logs Difference"}
        id={Source}
        header={true}
      >
        <JsonContainer id="jsoncontainer">
          <JsonDiffReact left={old_value} right={updated_value} show={true} />
        </JsonContainer>
      </NoFooterModal>
    </div>
  );
};

const JsonContainer = styled.div`
  padding: 2rem;
`;

export default ChangeLogsDiffModal;
